import { InjectionKey } from 'vue'

interface LayoutData {
  header: { height: number; offset: number }
  footer: { height: number; offset: number }
  float: { bottom: { height: number } }
}

const LayoutDataKey: InjectionKey<LayoutData> = Symbol('LayoutData')

export type { LayoutData }
export { LayoutDataKey }
